<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 操作-->
        <!--工具条-->
        <div>
        <el-select class="m-1" v-model="kioskNo" placeholder="机器编号" @change="change()">
            <el-option label="全部售货机" value="">全部售货机</el-option>
            <el-option
                    v-for="(item,index) in kioskList"
                    :label="item.deviceName"
                    :value="item.deviceId"
            >
            </el-option>
        </el-select>

         <el-button type="danger"  @click="synProduct()" icon="search":loading="synloading">商品同步</el-button>

        </div>

        <div class="block">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- ======================已上架================= -->
            <el-tab-pane label="已上架" name="first">
                <el-input v-model="productName" placeholder="商品名称" style="width: 20%"></el-input>
                <el-button type="primary" class="" @click="findpushData()" icon="search":loading="loading">查询</el-button>
                <el-button type="primary" @click="resetForm()">重置</el-button>
                <el-button type="primary" :disabled="true">导出</el-button>
                <el-button type="primary" :disabled="this.pushmultipleSelection.length > 0 == false "  @click="pushProduct()">商品下架</el-button>

                <el-table ref="multipleTable" :data="pushData" tooltip-effect="dark" style="width: 100%" @selection-change="pushSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column align="center" prop="Image" label="商品图片"  >
                        <template slot-scope="scope">
                            <img :src="scope.row.Image" class="avatar" style="height: 50px;">
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="商品名称" > </el-table-column>
                    <el-table-column prop="price" label="商品价格" > </el-table-column>
                    <el-table-column prop="kioskNo" label="机器编号" > </el-table-column>
                    <el-table-column prop="categoriesName" label="品类" > </el-table-column>
                    <el-table-column prop="ppwPrice" label="线上价格" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.ppwPrice != scope.row.price" style="color:red">{{ scope.row.ppwPrice }}</span>
                            <span v-else >{{ scope.row.ppwPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="库存" > </el-table-column>
                    <el-table-column label="操作" width="255px">
                        <template scope="scope" >
                            <el-button style="background-color: #43c291; color: #fff;" @click="modify(scope.row)">编辑</el-button>
                            <el-button type="danger"  size="small" @click="outProductOpen(scope.row)" >商品下架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                            @current-change="pushhandleCurrentChange"
                            @size-chahange="pushhandleSizeChange"
                            :current-page="pushcurrentpage"
                            :page-count="pushpagesCount"
                            :page-sizes="pushpagesizes"
                            :page-size="pushpagesize"
                            :total="pushpagesCount"
                            layout=" total, prev, pager, next, jumper"
                    >
                    </el-pagination>
                </div>

            </el-tab-pane>
            <!-- ======================未上架================= -->
            <el-tab-pane label="未上架" name="second">
                <el-input v-model="productPushName" placeholder="商品名称" style="width: 20%"></el-input>
                <el-button type="primary" class="" @click="findpullData()" icon="search":loading="loading">查询</el-button>
                <el-button type="primary" @click="resetpushForm()">重置</el-button>
                <el-button type="primary" :disabled="true">导出</el-button>
                <el-button type="primary" :disabled="this.pullmultipleSelection.length > 0 == false " @click="pullProduct()">商品上架</el-button>

                <el-table ref="multipleTable" height="550" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="pullSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column align="center" prop="Image" label="商品图片"  >
                        <template slot-scope="scope">
                            <img :src="scope.row.Image" class="avatar" style="height: 50px;">
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="商品名称" > </el-table-column>
                    <el-table-column prop="price" label="商品价格" > </el-table-column>
                    <el-table-column prop="kioskNo" label="机器编号" > </el-table-column>
                    <el-table-column prop="categoriesName" label="品类" > </el-table-column>
                    <el-table-column prop="available" label="库存" > </el-table-column>
                    <el-table-column label="操作" width="155px">
                        <template scope="scope" >
                            <el-button type="danger"  size="small" @click="putawayProductOpen(scope.row)" >商品上架</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="block">
                    <el-pagination
                            @current-change="pullhandleCurrentChange"
                            @size-chahange="pullhandleSizeChange"
                            :current-page="pullcurrentpage"
                            :page-count="pullpagesCount"
                            :page-sizes="pullpagesizes"
                            :page-size="pullpagesize"
                            :total="pullpagesCount"
                            layout=" total, prev, pager, next, jumper"
                    >
                    </el-pagination>
                </div>

            </el-tab-pane>
        </el-tabs>
        </div>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    import ElDialog from "../../../../node_modules/element-ui/packages/dialog/src/component.vue";
    export  default{
        components: {ElDialog},
        data(){
            return {
                activeName: 'first',
                kioskNo: '',
                productName: '',
                productPushName: '',
                //页眉设置参数
                pullcurrentpage: 1,//当前页数默认是1
                pushcurrentpage: 1,//当前页数默认是1
                pullpagesCount: 0, //总数默认0
                pushpagesCount: 0, //总数默认0
                pullpagesizes: [10, 20, 30],//条数列
                pushpagesizes: [10, 20, 30],//条数列
                pullpagesize: 10,//行数
                pushpagesize: 10,//行数
                pullactiveNum: 0, //默认起始行数
                pushactiveNum: 0, //默认起始行数
                pullendNum: 10,//默认结束行数
                pushendNum: 10,//默认结束行数
                ///////////////////////
                tableData: [], // 分页组件传回的分页后数据
                pushData: [], // 分页组件传回的分页后数据
                kioskList:[],
                /*弹窗选择*/
                loading:false,
                isorno:false,
                synloading:false,
                pushmultipleSelection:[],
                pullmultipleSelection:[],
            }

        },
        created(){
            this.getData();
            this.kioskLists();
            this.getpushData();
        },
        methods: {
            findpullData(){
                this.pullactiveNum = 0;
                this.pullcurrentpage = 1;
                this.pullpagesize = 10;
                this.getData();
            },findpushData(){
                this.pushactiveNum = 0;
                this.pushcurrentpage = 1;
                this.pushpagesize = 10;
                this.getpushData();
            },
            pullhandleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pullpagesize=val
                this.pullactiveNum=(val*this.pullcurrentpage)-val;
                this.pullendNum=(val*this.pullcurrentpage)
                this.getData();
                //数目变更
            },
            pushhandleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pushpagesize=val
                this.pushactiveNum=(val*this.pushcurrentpage)-val;
                this.pushendNum=(val*this.pushcurrentpage)
                this.getpushData();
                //数目变更
            },
            pullhandleCurrentChange(val){
                this.pullcurrentpage=val;
                this.pullactiveNum=(this.pullpagesize*val)-this.pullpagesize
                this.pullendNum=(this.pullpagesize*val)
                this.getData();
            },
            pushhandleCurrentChange(val){
                this.pushcurrentpage=val;
                this.pushactiveNum=(this.pushpagesize*val)-this.pushpagesize
                this.pushendNum=(this.pushpagesize*val)
                this.getpushData()
            },
            change(){
                this.findpullData();
                this.findpushData();
            },
            resetpushForm() {
                this.productPushName = '';
                this.findpullData();
            },resetForm() {
                this.productName = '';
                this.findpushData();
            },
            kioskLists(){
                //数据请求
                var params = {orgIds:'6P86B3U8',tenantId:this.getcookie('storeId'),Token:'12345'};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/findDeviceList",{
                    params: params})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.kioskList = response.body.Data;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.getData();
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {active:this.pullactiveNum,len:this.pullpagesize,kioskNo:this.kioskNo,tenantId:this.getcookie('storeId'),
                    productName:this.productPushName};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/getProductNotPutaway",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.tableData = response.body.Data.data
                                this.pullpagesCount = response.body.Data.count
                                this.loading = false;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
                this.fileSpan();
            },
            getpushData(){
                //数据请求
                this.loading = true
                var params = {active:this.pushactiveNum,len:this.pushpagesize,kioskNo:this.kioskNo,tenantId:this.getcookie('storeId'),
                    productName:this.productName};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/getProductPutaway",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.pushData = response.body.Data.data
                                this.pushpagesCount = response.body.Data.count
                                this.loading = false;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
                this.fileSpan();
            },
            fileSpan(){
                this.isorno=false;
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            /**--------------------------------------商品同步--------------------------------------------------------**/
            synProduct(){
                this.centerDialogVisible = false;
                this.synloading = true;

                var params = {kioskNo:this.kioskNo,tenantId:this.getcookie('storeId'),token:"123456"};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/syncProducts",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.code=='200'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'success' });
                                this.synloading = false;
                            }else{
                                this.$message({ showClose: true, message: "同步失败",  type: 'error' });
                                this.synloading = false;
                            }
                        }
                        this.getData();
                        this.getpushData();
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            /**--------------------上架页面-----------------**/
            pushSelectionChange(val) {
                this.pushmultipleSelection = val;
            },
            modify(row){
                this.$router.push( {path:"productModify",query:{SKU:row.SKU,kioskNo:row.kioskNo,
                    productName:row.productName,price:row.price,
                    ppwPrice:row.ppwPrice,categoriesName:row.categoriesName,available:row.num,Image:row.Image}});
            },
            //商品下架
            pushProduct(){
                console.log(this.pushmultipleSelection);
                for (var i = 0;i<this.pushmultipleSelection.length;i++) {
                    var SKU = this.pushmultipleSelection[i].SKU;
                    var kioskNo = this.pushmultipleSelection[i].kioskNo;

                    //数据请求
                    this.loading = true
                    var params = {kioskNo:kioskNo,tenantId:this.getcookie('storeId'),SKU: SKU};
                    //异步请求
                    this.$http.post(this.productURL+"/vueFeign/outProduct",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.code=='200'){
                                    this.$message({ showClose: true, message: response.body.msg,  type: 'success' });
                                    this.loading = false;
                                }else{
                                    this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                                    this.loading = false;
                                }
                            }
                            this.findpullData();
                            this.findpushData();
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }
            },
            outProductOpen(row){
                //数据请求
                this.loading = true
                var params = {kioskNo:row.kioskNo,tenantId:this.getcookie('storeId'),SKU: row.SKU};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/outProduct",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.code=='200'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'success' });
                                this.loading = false;
                            }else{
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                                this.loading = false;
                            }
                        }
                        this.findpullData();
                        this.findpushData();
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            /**---下架页面----------**/
            pullSelectionChange(val) {
                this.pullmultipleSelection = val;
            },
            //选择商品上架
            pullProduct(){
                console.log(this.pullmultipleSelection);
                for (var i = 0;i<this.pullmultipleSelection.length;i++){
                    var SKU = this.pullmultipleSelection[i].SKU;
                    var available = this.pullmultipleSelection[i].available;
                    var price = this.pullmultipleSelection[i].price;
                    var kioskNo = this.pullmultipleSelection[i].kioskNo;

                    var params = {price:price,kioskNo:kioskNo,tenantId:this.getcookie('storeId'),SKU:SKU,putawayNum:available};

                    //异步请求
                    this.$http.post(this.productURL+"/vueFeign/putawayProduct",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.code=='200'){
                                    this.putawayProductVisible = false;
                                    this.$message({ showClose: true, message: response.body.msg,  type: 'success' });
                                }else{
                                    this.putawayProductVisible = false;
                                    this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                                }
                            }
                            this.findpullData();
                            this.getpushData();
                        },function(response){
                            this.putawayProductVisible = false;
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }
            },
            //单个商品上架
            putawayProductOpen(row){
                var params = {price:row.price,kioskNo:row.kioskNo,tenantId:this.getcookie('storeId'),SKU:row.SKU,putawayNum:row.available};

                //异步请求
                this.$http.post(this.productURL+"/vueFeign/putawayProduct",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.code=='200'){
                                this.putawayProductVisible = false;
                                this.$message({ showClose: true, message: response.body.msg,  type: 'success' });
                            }else{
                                this.putawayProductVisible = false;
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.findpullData();
                        this.getpushData();
                    },function(response){
                        this.putawayProductVisible = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
        }

    }

</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .customWidth {
        width: 60%;
    }
    .box_relative{
        float: left;
    }
</style>


// WEBPACK FOOTER //
// productMananger.vue?683d06fd